import { UPDATE_USER_PASSWORD } from 'actions/Types';

export default (state = false, action) => {
  if (action.type === `${UPDATE_USER_PASSWORD}_FAILURE`) {
    const { status, statusText } = action.payload;
    return {
      status,
      statusText
    };
  }

  if (action.type === `${UPDATE_USER_PASSWORD}_SUCCESS`) {
    return state;
  }

  return state;
};
